import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PageHeader from "../elements/PageHeader";
import config from '../../config/config.js';
import axios from 'axios';
import Select2 from 'react-select2-wrapper';
import swal from 'sweetalert';

class UserManagementScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            loading: true,
            adding: false,
            editing: false,
            editId: 0,
            addEditUserUsername: '',
            addEditUserPassword: '',
            addEditUserEnabled: false,
            addEditUserRoles: [],
            availableRoles: [],
            addEditErrors: []
        };

        this.loadUsers = this.loadUsers.bind(this);
        this.handleStartAddingUser = this.handleStartAddingUser.bind(this);
        this.handleStartEditUser = this.handleStartEditUser.bind(this);
        this.handleAddUser = this.handleAddUser.bind(this);
        this.handleEditUser = this.handleEditUser.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectInputChange = this.handleSelectInputChange.bind(this);
        this.handleDeleteUser = this.handleDeleteUser.bind(this);
        this.handleCancelAddEditUser = this.handleCancelAddEditUser.bind(this);
    }

    componentDidMount() {
        this.loadUsers();
    }

    handleStartAddingUser() {
        this.setState({
            adding: true
        });
    }

    handleStartEditUser(userId) {
        let user = this.state.users.find((el) => {
            return el.id === parseInt(userId)
        });
        this.setState({
            editing: true,
            editId: user.id,
            addEditUserUsername: user.username,
            addEditUserPassword: '',
            addEditUserEnabled: user.enabled,
            addEditUserRoles: user.roles,
            addEditErrors: []
        });
        window.scrollTo(0, 0);
    }

    loadUsers() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/users', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    loading: false,
                    users: response.data.users,
                    availableRoles: response.data.availableRoles
                });
            }
        });
    }

    handleAddUser(e) {
        e.preventDefault();
        let that = this;
        axios(config.server.endpoint + 'backend/user', {
            method: 'post',
            data: {
                username: this.state.addEditUserUsername,
                password: this.state.addEditUserPassword,
                enabled: this.state.addEditUserEnabled,
                roles: this.state.addEditUserRoles.join(',')
            }
        }).then((response) => {
            if(response.status === 200) {
                if(response.data.success === true) {
                    that.setState({
                        adding: false,
                        errors: [],
                        editing: false,
                        editId: 0,
                        addEditUserUsername: '',
                        addEditUserPassword: '',
                        addEditUserRoles: [],
                        addEditUserEnabled: false,
                    });
                    that.loadUsers();
                } else {
                    that.setState({
                        addEditErrors: response.data.errors
                    })
                }

            }
        })
    }

    handleEditUser(e) {
        e.preventDefault();
        let that = this;
        axios(config.server.endpoint + 'backend/user/' + this.state.editId, {
            method: 'put',
            data: {
                username: this.state.addEditUserUsername,
                password: this.state.addEditUserPassword,
                enabled: this.state.addEditUserEnabled,
                roles: this.state.addEditUserRoles.join(',')
            }
        }).then((response) => {
            if(response.status === 200) {
                if(response.data.success === true) {
                    that.setState({
                        editing: false,
                        errors: [],
                        adding: false,
                        editId: 0,
                        addEditUserUsername: '',
                        addEditUserPassword: '',
                        addEditUserRoles: [],
                        addEditUserEnabled: false
                    });
                    that.loadUsers();
                } else {
                    that.setState({
                        addEditErrors: response.data.errors
                    })
                }

            }
        })
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSelectInputChange(e) {
        this.setState({
            [e.target.name]: [...e.target.options].filter(({selected}) => selected).map(({value}) => value)
        });
    }

    handleDeleteUser(userId) {
        const { t } = this.props;

        swal({
            title: t('userManagementScreen.user.delete.really.title'),
            text: t('userManagementScreen.user.delete.really.text'),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                axios(config.server.endpoint + 'backend/user/' + userId, {
                    method: 'delete'
                }).then((response) => {
                    this.loadUsers();
                })
            }
        })
    }

    handleCancelAddEditUser(e) {
        e.preventDefault();
        this.setState({
            adding: false,
            editing: false,
            addEditUserUsername: '',
            addEditUserPassword: '',
            addEditUserRoles: [],
            addEditErrors: [],
            addEditUserEnabled: false
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="UserManagementScreen">
                <PageHeader title={t('userManagementScreen.title')}/>
                <div className="m-t">
                    <button className="pull-right btn btn-primary m-b" onClick={this.handleStartAddingUser}>
                        {t('userManagementScreen.addUser')}
                    </button>
                    {this.state.loading ? (
                        <i className='fa fa-spinner fa-spin fa-3x'/>
                    ) : null}
                </div>
                {this.state.adding || this.state.editing ? (
                    <div className="ibox m-t">
                        <div className="ibox-title">
                            <h5>
                                {t('userManagementScreen.addEditUser')}
                            </h5>
                        </div>
                        <div className="ibox-content">
                            <form onSubmit={this.state.adding ? this.handleAddUser : this.handleEditUser }>
                                <div className="row">
                                    <div className="col-xs-3">
                                        <div
                                            className={"form-group" + ((this.state.addEditErrors && this.state.addEditErrors.username) ? ' has-error' : '')}>
                                            <label>{t('userManagementScreen.username')}</label>
                                            <input className="form-control" name="addEditUserUsername" value={this.state.addEditUserUsername}
                                                   type="text"
                                                   onChange={this.handleInputChange}/>
                                            {(this.state.addEditErrors && this.state.addEditErrors.username) ? (
                                                <span className="help-block">
                                            {t('userManagementScreen.username.error.' + this.state.addEditErrors.username)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-xs-3">
                                        <div
                                            className={"form-group" + ((this.state.addEditErrors && this.state.addEditErrors.password) ? ' has-error' : '')}>
                                            <label>{t('userManagementScreen.password' + (this.state.editing ? '.edit' : ''))}</label>
                                            <input className="form-control" name="addEditUserPassword" value={this.state.addEditUserPassword}
                                                   type="password"
                                                   onChange={this.handleInputChange}/>
                                            {(this.state.addEditErrors && this.state.addEditErrors.password) ? (
                                                <span className="help-block">
                                            {t('userManagementScreen.password.error.' + this.state.addEditErrors.password)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-xs-2">
                                        <div
                                            className={"form-group" + ((this.state.addEditErrors && this.state.addEditErrors.enabled) ? ' has-error' : '')}>
                                            <label>{t('userManagementScreen.enabled')}</label>
                                            <input className="form-control" name="addEditUserEnabled" checked={this.state.addEditUserEnabled}
                                                   type="checkbox"
                                                   onChange={() => this.setState({addEditUserEnabled: !this.state.addEditUserEnabled})}/>
                                            {(this.state.addEditErrors && this.state.addEditErrors.enabled) ? (
                                                <span className="help-block">
                                            {t('userManagementScreen.enabled.error.' + this.state.addEditErrors.enabled)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-xs-4">
                                        <div
                                            className={"form-group" + ((this.state.addEditErrors && this.state.addEditErrors.roles) ? ' has-error' : '')}>
                                            <label>{t('userManagementScreen.roles')}</label>
                                            <Select2 multiple data={this.state.availableRoles.map((el) => {
                                                return {
                                                    text: t('default.role.' + el), id: el
                                                }
                                            })} value={this.state.addEditUserRoles} onChange={this.handleSelectInputChange} name="addEditUserRoles"
                                                     options={{placeholder: t('userManagementScreen.roles.placeholder')}}
                                                     className="width-100p block"/>
                                            {(this.state.addEditErrors && this.state.addEditErrors.roles) ? (
                                                <span className="help-block">
                                            {t('userManagementScreen.roles.error.' + this.state.addEditErrors.roles)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="row text-right">
                                    <button type="button" className="btn btn-default" onClick={this.handleCancelAddEditUser}>
                                        {t('default.cancel')}
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        {t('default.save')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                ) : null}
                <table className="table m-t">
                    <thead>
                        <tr>
                            <th>
                                {t('userManagementScreen.username')}
                            </th>
                            <th>
                                {t('userManagementScreen.roles')}
                            </th>
                            <th>
                                {t('userManagementScreen.enabled')}
                            </th>
                            <th/>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.users.map((user, i) => (
                            <tr key={i}>
                                <td>
                                    {user.username}
                                </td>
                                <td>
                                    {user.roles.map((role, j) => (
                                        <span key={j} className="label label-primary m-r-xs">
                                            {t('default.role.' + role)}
                                        </span>
                                    ))}
                                </td>
                                <td>
                                    {user.enabled ? (
                                        <i className="fa fa-check text-primary"/>
                                    ) : (
                                        <i className="fa fa-close text-danger"/>
                                    )}
                                </td>
                                <td className="text-right">
                                    <div className="btn-group btn-group-xs">
                                        <button type="button" onClick={() => this.handleStartEditUser(user.id)}
                                                className="btn btn-primary">
                                            <i className="fa fa-pencil"/>
                                        </button>
                                        <button type="button" onClick={() => this.handleDeleteUser(user.id)}
                                                className="btn btn-danger">
                                            <i className="fa fa-trash"/>
                                        </button>

                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}
export default translate()(UserManagementScreen);
